import {http} from './config';
export default{
    save:(empresa)=>{
        return http.post('api/compra',compra)
    },
    delete:()=>{
        return http.delete('api/compra/')
    },
    obtenerEmpresaPorUsuario:()=>{
        return http.get('api/compra/')
    }
}
